import * as jsPDF from 'jspdf';
import * as html2canvas from "html2canvas";

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Injectable, ElementRef, Renderer2 } from '@angular/core';
import { Validators } from '@angular/forms';
import { style } from '@angular/core/src/animation/dsl';


@Injectable()
export class PdfExporterServiceConciliacion {

  constructor(private renderer: Renderer2) { }

  /**
   * Export an html section to pdf file.
   * @param container Container with the component that have a pdf template
   * @param fileName Name of exported file.
   * @param exportOptions options of exported file (measurements)
   */
  async export(container: any, fileName: string,showPrice:boolean) {
    const doc = new jsPDF("p", "pt", "letter");
  
    const documentDefinition = {
      content: [
        {
          columns: [
            {
              columns: [
                {
                  width: '*',
                  stack: [
                    { text: container.companyName.FISCAL_NAME, style: 'header', alignment: 'center', margin: [0, 0, 0, 2] }, // margen inferior pequeño
                    { text: 'Conciliación', style: 'header', alignment: 'center', margin: [0, 0, 0, 10] }
                  ],
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                }
                ,
                {
                  width: 'auto',
                  text: new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
                  alignment: 'right',
                  margin: [0, 0, 0, 0],
                  style: 'txtData'
                }
              ]
            }
          ]
        },
        {
          style: 'table2',
          table: {
            widths: [100, '*', 5, 120, '*'],
            body: [
              [
                { text: 'Cuenta Bancaria', style: 'txtData', border: [false, false, false, false] },
                { text: container.details[0].BANK_ACCOUNT_NAME, style: 'txtDataConcepto', bold: true },
                { text: '', border: [false, false, false, false] },
                { text: 'No. Conciliación', style: 'txtData', border: [false, false, false, false] },
                { text: container.details[0].CONCILIATION_NUMBER, alignment: 'right', style: 'txtDataConcepto' }
              ],
              [
                { text: 'Banco', style: 'txtData', border: [false, false, false, false] },
                { text: container.details[0].BANK_NAME, style: 'txtDataConcepto', bold: true },
                { text: '', border: [false, false, false, false] },
                { text: 'Fecha Conciliación', style: 'txtData', border: [false, false, false, false] },
                { text: this.formatFecha(container.details[0].CONCILIATION_DATE), alignment: 'right', style: 'txtDataConcepto' }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [100, 90, 100],
            body: [
              [
                { text: 'Fecha', alignment: 'left', style: 'txtDataConcepto', bold: true },
                { text: 'Concepto', alignment: 'left', style: 'txtDataConcepto', bold: true },
                { text: 'Importe', alignment: 'left', style: 'txtDataConcepto', bold: true }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [200, 100],
            body: [
              [
                { text: 'Saldo Cuenta Banco',bold: true, style: 'txtDataConcepto', border: [false, false, false, false] },
                { text:this.formatCurrency(container.details[0].ACCOUNTING_BALANCE) , style: 'txtData', bold: true, border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [200],
            body: [
              [
                { text: 'Egresos en Tránsito', style: 'txtDataConcepto', border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [100,100,'*'],
            body: this.createTableEgresos(container) 
          }
        },
        {
          style: 'table2',
          table: {
            widths: [205, 100],
            body: [
              [
                { text: 'Total Egresos en Tránsito', style: 'txtDataConcepto', border: [false, false, false, false] },
                { text:this.formatCurrency(container.details[0].EXPENDITURE_IN_TRANSIT) , style: 'txtData', bold: true, border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [200],
            body: [
              [
                { text: 'Ingresos en Tránsito', style: 'txtDataConcepto', border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [100,100,'*'],
            body: this.createTableIngresos(container) 
          }
        },
        {
          style: 'table2',
          table: {
            widths: [205, 100],
            body: [
              [
                { text: 'Total Ingresos en Tránsito', style: 'txtDataConcepto', border: [false, false, false, false] },
                { text:this.formatCurrency(container.details[0].ACCOUNTING_BALANCE) , style: 'txtData', bold: true, border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [205, 100],
            body: [
              [
                { text: 'Saldo Contabilidad', style: 'txtDataConcepto', border: [false, false, false, false] },
                { text: this.formatCurrency(container.details[0].CONCILIATION_BALANCE), style: 'txtData', bold: true, border: [false, false, false, false] }
              ]
            ]
          }
        },
        {
          style: 'table2',
          table: {
            widths: [205, 100],
            body: [
              [
                { text: 'Diferencia', style: 'txtDataConcepto', border: [false, false, false, false] },
                { text:this.formatCurrency(container.details[0].DIFFERENCE) , style: 'txtData', bold: true, border: [false, false, false, false] }
              ]
            ]
          }
        }
      ],
    
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
          fontSize: 8
        },
        table1: {
          margin: [10, 10, 0, 0]
        },
        tableHeader: {
          bold: true,
          fontSize: 9,
          color: 'black'
        },
        header: {
          bold: true,
          fontSize: 13,
          color: 'black',
          margin: [0, -5, 0, 0]
        },
        txtData: {
          //bold: true,
          fontSize: 9,
          color: 'black'
        },
        txtDataConcepto: {
          bold: true,
          fontSize: 10,
          color: 'black'
        },
        table2: {
          margin: [0, 5, 5, 10]
        }
      },
      pageMargins: [20, 20, 20, 20]
    };
    
    let x = pdfMake.createPdf(documentDefinition).download(fileName);

  }

  formatCurrency(value) {
    return '$' + parseFloat(value).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  createTableEgresos(container) {
    let body = [];
    if(container.detailsPolizaEgresos.length != 0){
      container.detailsPolizaEgresos.forEach(detailP => {
        body.push([
          { text:this.formatFecha( detailP.CREATION_DATE), style: 'txtData', border: [false, false, false, false] },
          { text: detailP.CONCEPT, style: 'txtData', border: [false, false, false, false] },
         { text:this.formatCurrency(detailP.importe) , style: 'txtDataConcepto', border: [false, false, false, false] }
        ]);
      });
    }else{
      body.push([{text: '',style: 'txtData',border: [false, false, false, false]}]);
    }

    return body;
  }

  createTableIngresos(container) {
    let body = [];

    if(container.detailsPolizaIngresos.length != 0){
      container.detailsPolizaIngresos.forEach(detailP => {
        body.push([
          { text: this.formatFecha( detailP.CREATION_DATE), style: 'txtData', border: [false, false, false, false] },
          { text: detailP.CONCEPT, style: 'txtData', border: [false, false, false, false] },
        { text:this.formatCurrency(detailP.importe) , style: 'txtDataConcepto', border: [false, false, false, false] }
        ]);
      });
    }else{
      body.push([{text: '',style: 'txtData',border: [false, false, false, false]}]);
    }
    
    return body;
  }


  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
  
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
  
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
  
        var dataURL = canvas.toDataURL("image/png");
  
        resolve(dataURL);
      };
  
      img.onerror = error => {
        reject(error);
      };
  
      img.src = url;
    });
  }

  isShowPrice(showPrice,precio){
    const formatterDolar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    let valor

    if(showPrice == true){
      return formatterDolar.format(precio);
    }else{
      return '--';
    }
    
  }

  isShowPriceHasDiscount(showPrice,hasDiscount,detail){

    if(!showPrice){
      return '--'
    }else{
     if(hasDiscount == 0){
      return this.isShowPrice(showPrice,detail.priceNoDiscount);
     }else{
      return this.isShowPrice(showPrice,detail.price);
     }
    }    
  }

  isShowPriceHasDiscountTotal(showPrice,hasDiscount,detail){

    if(!showPrice){
      return '--'
    }else{
     if(hasDiscount == 0){
      return this.isShowPrice(showPrice,detail.totalNoDiscount);
     }else{
      return this.isShowPrice(showPrice,detail.total);
     }
    }    
  }

  formatFecha(fecha){
    var date = new Date(fecha);
    let formatted_date = this.agregarCeroMesDia(date.getDate()) + "/" + this.agregarCeroMesDia((date.getMonth() + 1)) + "/" + date.getFullYear()
     return formatted_date;
  }

  agregarCeroMesDia(numero){

    switch(numero){
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        return '0'+numero;
      default:
        return numero;
    }


  }
}

interface CanvasOptions {
  xCoordinate: number;
  yCoordinate: number;
  width: number;
  height: number;
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/conciliacionBancaria/service/pdf-exporter.service.ts